import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function SentryFeedbackManager() {
    const location = useLocation();

    useEffect(() => {
        const widget = document.querySelector('#sentry-feedback');
        if (!widget) return;

        if (location.pathname.includes('/login') || location.pathname === '/') {
            widget.setAttribute('style', 'display: none !important; visibility: hidden !important; position: fixed !important; left: -9999px !important; top: -9999px !important; pointer-events: none !important;');
        } else {
            widget.setAttribute('style', 'position: fixed; bottom: 15px; right: 15px;');
        }
    }, [location.pathname]);

    return null;
}